import { Outlet } from "react-router-dom";
import { useState } from "react";
import ToastNotification from "./shared/components/toast-notification/ToastNotification";
import "./App.scss";

export type OutletContext = {
  setAlert: (info: { alertType: string; alertMsg: string }) => void;
};

const AppLayout = () => {
  const [toastNotificationInfo, setToastNotificationInfo] = useState<{
    alertType?: string;
    alertMsg?: string;
  }>({});

  const setAlert = (toastNotificationInfo: { alertType: string; alertMsg: string }) => {
    setToastNotificationInfo({
      alertType: toastNotificationInfo.alertType,
      alertMsg: toastNotificationInfo.alertMsg,
    });
  };

  return (
    <div>
      {/* This is where all route children render */}
      <Outlet context={{ setAlert }} />

      {toastNotificationInfo.alertType && toastNotificationInfo.alertMsg && (
        <ToastNotification
          alertType={toastNotificationInfo.alertType}
          alertMsg={toastNotificationInfo.alertMsg}
          closeAlert={() => setToastNotificationInfo({})}
        />
      )}
    </div>
  );
};

export default AppLayout;
